<template>
  <div class="qr-code-wrapper">
    <!-- <Header :title="title" :rightContent="rightContent"></Header> -->
    <div class="qr-code-image">
      <!-- <img :src="qrCode" alt="deposit qr code"/> -->
      <span>{{ qrCodeCRC }}</span>
      <QrCodeVue
        v-if="qrCode !== ''"
        ref="qrCodeRef"
        :value="qrCode"
        :size="220"
      />
      <p v-if="qrCode === ''" style="font-size: 0.35rem; color: red; text-align: center; border: 1px solid rgba(15, 15, 15, 0.3); padding: 0.3rem; border-radius: 5px">钱包地址获取失败</p>
    </div>
    <p class="center text-sm bold">
      {{ rechargeData.payName }}协议
    </p>
    <span class="text-md bold" style="margin-top: 1rem">
      发送您的USDT存款至：
    </span>
    <div class="wallet-address-container">
      <input disabled :value="depositTargetAddress" class="wallet-address text-lg">
      <button ref="copyButton" class="text-lg" :data-clipboard-text="depositTargetAddress">复制</button>
    </div>
    <p class="text-md bold">
      温馨提示<br>
      <ul class="number">
        <li>请勿充值任何非{{ rechargeData.payName }}资产，如使用非本协议方式及地址存款,该笔资金将会遗失,客户需自行承担</li>
        <li>USDT存款需经区块链节点确认，实际到账时间取决于区块链情况</li>
      </ul>
    </p>
    <div class="helper-text-container">
      <p class="text-md" style="margin-bottom: 0.2rem">没有币，怎么充值？</p>
      <ul class="special-list text-sm">
        <li><span>1</span>
          <span>先在交易所买币，保证钱包余额充足；交易所可选
            <em
              v-for="(ele,index) in exchangeCenter"
              :key="'exchange-center-' + index"
              @click="directToExchangeCenter(ele.url)"
            >
              {{ ele.name }} {{ index + 1 !== exchangeCenter.length ? ", " : "" }}
            </em>
            等
          </span>
        </li>
        <li>
          <span>2</span>
          <span>买完币后，可按照生成的地址和二维码完成充值操作</span>
        </li>
      </ul>
    </div>
    <Chat />
    <ToHome />
    <AlertPop
      :model="alertPop.show"
      :button1txt="alertPop.button1Txt"
      :auto-hide-duration="1000"
      :content="'复制成功'"
      @alertOnClose="alertOnClose"
    />
  </div>
</template>

<script>
require('@/assets/css/rechargeQRCode.css')
import { mapState } from 'vuex'
// import Header from "@/view/module/Header.vue";
import ToHome from '@/view/module/ToHome.vue'
import Chat from '@/view/module/Chat.vue'
import QrCodeVue from 'qrcode.vue'
import AlertPop from '@/view/module/AlertPop.vue'
import Clipboard from 'clipboard'
export default {
  name: 'RechargeQRCode',
  components: { ToHome, Chat, QrCodeVue, AlertPop },
  data() {
    return {
      title: '确认存款',
      rightContent: 'recharge',
      qrCode: '',
      qrCodeCRC: '',
      blockchainType: 'ERC20协议',
      depositTargetAddress: '',
      alertPop: {
        show: false
      },
      exchangeCenter: [
        {
          name: '火币',
          url: 'https://www.huobi.com/zh-cn/'
        },
        {
          name: '币安',
          url: 'https://www.binance.com/'
        },
        {
          name: 'Coinbase',
          url: 'https://www.coinbase.com/'
        },
        {
          name: 'Okex',
          url: 'https://www.okex.com/'
        },
        {
          name: 'Bitcoin',
          url: 'https://bitcoin.org/'
        }
      ]
    }
  },
  mounted() {
    if (this.$route.query.imgQrCode) {
      this.qrCode = this.$route.query.imgQrCode
      this.qrCodeCRC = this.$route.query.crc
      this.depositTargetAddress = this.$route.query.imgQrCode
    }
    const _this = this
    const clipboard = new Clipboard(_this.$refs.copyButton)
    clipboard.on('success', () => {
      _this.alertPop = {
        show: true,
        content: '复制成功',
        autoHideDuration: 500
      }
    })
    clipboard.on('error', () => {
      _this.alertPop = {
        show: true,
        content: '复制失败，请手动选择复制！',
        autoHideDuration: 500
      }
    })
  },
  updated() {
    const canvas = this.$refs.qrCodeRef.$el.querySelector('canvas')
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = 'rgba(255, 0, 0, 0.4)'
    ctx.textAlign = 'center'
    ctx.font = 'bold 16px sans-serif'
    ctx.textBaseline = 'middle'
    ctx.rotate(Math.PI / 180 * -45)
    ctx.translate(0, 270)
    ctx.fillText(this.qrCodeCRC || '', 0, 0)
    // const image = canvas.toDataURL('image/jpeg', 1.0)
    // console.log(image)
  },
  computed: {
    ...mapState(['rechargeData'])
  },
  methods: {
    directToExchangeCenter(url) {
      window.open(url, '_blank')
    },
    alertOnClose() {
      this.alertPop = {
        show: false
      }
    },
    async copyToClipboard() {
      if (window.location.protocol.match(/https/gi) && navigator.clipboard) {
        await navigator.clipboard.writeText(this.depositTargetAddress)
        await navigator.clipboard.readText()
        this.alertPop = {
          show: true,
          content: '复制成功',
          autoHideDuration: 500
        }
      } else {
        const textArea = document.createElement('textarea')
        textArea.value = this.depositTargetAddress
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.alertPop = {
          show: true,
          content: '复制成功',
          autoHideDuration: 500
        }
      }
    }
  }
}
</script>
